<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Grouped products</h1>
    </div>

    <div class="dropdown">
      <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Actions
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" v-on:click="modalEditProduct()"><i class="fas fa-pencil-alt"></i> Edit</a>
        <a class="dropdown-item" v-on:click="sRelatedProducts()"><i class="fas fa-layer-group"></i> Relate products</a>
        <a class="dropdown-item" v-on:click="delProductsModal()" href="#"><i class="fas fa-trash"></i> Delete</a>
      </div>
    </div>

    <button type="button" class="btn btn-primary" v-on:click="modalImport()"> Import</button>

    </div>

    <br /><br />

    <vue-good-table v-if="products"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          class="mb-3 px-4"
          @on-selected-rows-change="selectionChanged"
          @on-cell-click="onRowClick"
          :columns="productColumns"
          :rows="products"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
          :selectOptions="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add grouped product</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input type="text" class="form-control" v-model="addNewGroupedProduct" placeholder="New grouped product..." />
            <select class="custom-select" v-model="updateGroupedProduct" required id="dropDown">
              <option disabled="true">Select grouped product</option>
              <option v-for="(product) in groupedproducts" :value="product.id" v-bind:key="product.id">{{ product.name }}</option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="saveGroupedProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="importModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Import products (.csv)</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning" role="alert">
              - Gebruik "|" als afscheidingsteken in het .csv bestand<br>
              - De eerste kolom moet steeds het artikelnr. bevatten
            </div>
            <div class="input-group mb-1 fullw">
              <div class="custom-file fullw">
                <input type="file" ref="importfile" class="custom-file-input" v-on:change="handleImportUpload()" id="inputGroupFile02">
                <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">Choose file</label>
              </div>
            </div>
            <select class="fullw mt-2 custom-select" v-model="importType" :required="true">
              <option :value="-1" disabled="true">- Select import type -</option>
              <option value="new">New</option>
              <option value="update">Update</option>
              <option value="combo">New + Update</option>
            </select>
            <div class="input-group p-1">
              {{ importFeedback }}
            </div>
            <div class="input-group p-1">
              <form id="frmImport">
              <div v-for="(key) in csvKeys" v-bind:key="key" class="match-wrapper">
                <input disabled="disabled" class="form-control" type="text" :value="key"/>
                <select :name="key" class="custom-select">
                  <option :value="-1">- Select column -</option>
                  <option v-for="(sql, id) in sqlKeys" :value="id" v-bind:key="sql" :selected="sql == key">{{ sql }}</option>
                </select>
              </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="closeImport()">Close</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-secondary' : 'btn-primary'" v-on:click="uploadCSV()">Upload</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-primary' : 'btn-secondary'" v-on:click="importCSV()" :disabled="readyForImport ? false : true">{{ importStatus }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="deleteProductModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete product(s)</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="delSingleProducts" value="1">
              <label class="form-check-label" for="inlineCheckbox1">Onderliggende producten verwijderen</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="delProducts()">OK</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="editProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit grouped product</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Grouped product</a>
                <a class="nav-item nav-link" id="nav-attributes-tab" data-toggle="tab" href="#nav-attributes" role="tab" aria-controls="nav-attributes" aria-selected="false">Attributes</a>
                <a class="nav-item nav-link" id="nav-products-tab" data-toggle="tab" href="#nav-products" role="tab" aria-controls="nav-products" aria-selected="false">Products</a>
                <a class="nav-item nav-link" id="nav-related-tab" data-toggle="tab" href="#nav-related" role="tab" aria-controls="nav-related" aria-selected="false">Related</a>
                <a class="nav-item nav-link" id="nav-images-tab" data-toggle="tab" href="#nav-images" role="tab" aria-controls="nav-images" aria-selected="false">Images</a>
                <a class="nav-item nav-link" id="nav-woocommerce-tab" data-toggle="tab" href="#nav-woocommerce" role="tab" aria-controls="nav-woocommerce" aria-selected="false">WooCommerce</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <label>Database ID</label><input type="text" class="form-control" v-model="editProduct.id"/>
                <label>AN</label><input type="text" class="form-control" v-model="editProduct.an" placeholder="AN" />
                <label>Name (EN)</label><input type="text" class="form-control" v-model="editProduct.name" placeholder="Name (EN)" />
                <label>Name (NL)</label><input type="text" class="form-control" v-model="editProduct.name_nl" placeholder="Name (NL)" />
                <label>Name (FR)</label><input type="text" class="form-control" v-model="editProduct.name_fr" placeholder="Name (FR)" />
                <label>Trade</label><input type="text" class="form-control" v-model="editProduct.trade" placeholder="Trade" />
                <label>Retail</label><input type="text" class="form-control" v-model="editProduct.retail" placeholder="Retail" />
                <label>Tax(%)</label><input type="text" class="form-control" v-model="editProduct.tax" placeholder="Tax" />
                <label>Description (NL)</label>
                <quill-editor v-model="editProduct.desc_nl" :options="editorOption"></quill-editor>
                <label>Description (FR)</label>
                <quill-editor v-model="editProduct.desc_fr" :options="editorOption"></quill-editor>
                <label>Description (EN)</label>
                <quill-editor v-model="editProduct.desc_en" :options="editorOption"></quill-editor>
                <label>Active</label>
                <select class="form-control" v-model="editProduct.active" :selected="editProduct.active">
                  <option :value="1">Ja</option>
                  <option :value="0">Nee</option>
                </select>
              </div>
              <div class="tab-pane pt-3" id="nav-attributes" role="tabpanel" aria-labelledby="nav-attributes-tab">
                <div v-for="attr in editProduct.attributes" v-bind:key="attr.id">
                  <label>{{attr.name}}</label><input type="text" class="form-control" v-model="attr.value" :placeholder="attr.name" />
                </div>
              </div>
              <div class="tab-pane fade pt-3" id="nav-products" role="tabpanel" aria-labelledby="nav-related-tab">
                <table class="table">
                  <thead>
                    <th>AN</th>
                    <th>Name</th>
                    <th>Actions</th>
                  </thead>
                  <tbody v-for="product in editProduct.products" v-bind:key="product.id">
                  <tr>
                    <td>{{ product.an }}</td>
                    <td>{{ product.name }}</td>
                    <td><button @click="delProduct(product)" class="btn-secondary rounded btn-del">X</button></td>
                  </tr>
                  </tbody>
                </table>
                <vue-simple-suggest
                v-model="addGroupedProduct"
                mode="select"
                display-attribute="suggestion"
                value-attribute="id"
                :list="singleproducts"
                :filter-by-query="true"
              ></vue-simple-suggest>
              <button @click="addProduct()" class="btn-secondary rounded btn-add">Add</button>
              </div>
              <div class="tab-pane fade pt-3" id="nav-related" role="tabpanel" aria-labelledby="nav-related-tab">
                <table class="table">
                  <thead>
                    <th>AN</th>
                    <th>Name</th>
                    <th>Color</th>
                    <th>Actions</th>
                  </thead>
                  <tbody v-for="related in editProduct.related" v-bind:key="related.id">
                  <tr>
                    <td>{{ related.an }}</td>
                    <td>{{ related.name }}</td>
                    <td>{{ related.color }}</td>
                    <td><button v-if="related.id" @click="delRelatedProduct(related)" class="btn-secondary rounded btn-del">X</button></td>
                  </tr>
                  </tbody>
                </table>
                <vue-simple-suggest
                v-model="addRelatedProduct"
                mode="select"
                display-attribute="suggestion"
                value-attribute="id"
                :list="groupedproducts"
                :filter-by-query="true"
              ></vue-simple-suggest>
              <button @click="addNewRelatedProduct()" class="btn-secondary rounded btn-add">Add</button>
                <div>
                </div>
              </div>
              <div class="tab-pane fade pt-3" id="nav-images" role="tabpanel" aria-labelledby="nav-images-tab">
                <div class="input-group mb-1">
                  <table class="table">
                  <tbody>
                    <draggable v-model="editProduct.images" group="people" @start="drag=true" @end="drag=false" @change="imagesMoved()">
                         <tr v-for="img in editProduct.images" :key="img.id">
                           <td>{{ img.location }}</td>
                           <td><a target="_blank" :href="'https://wrc.weblion.be/images/' + img.location"><img class="preview" :src="'https://wrc.weblion.be/images/' + img.location"/></a></td>
                           <td><button v-if="img.id" @click="delImage(img)" class="btn-secondary rounded btn-del">X</button></td>
                         </tr>
                    </draggable>
                  </tbody>
                </table>
                </div>
                <div class="input-group mb-1">
                  <div class="custom-file">
                    <input accept="image/*" type="file" ref="file" class="custom-file-input" v-on:change="handleFileUpload()" id="inputGroupFile02" multiple>
                    <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">Choose file</label>
                  </div>
                </div>
                <div class="input-group mb-1">
                  <div class="col-sm p-0">
                    <p v-html="importFeedbackList" class="importFeedbackList pl-1"></p>
                  </div>
                  <div class="col-sm p-0 text-right">
                    <span class="importFeedback pr-2">{{importFeedback}}</span>
                    <button type="button" class="btn btn-primary m-0" :class="imgImportReady ? 'visible' : 'invisible'" v-on:click="importImages()">Upload</button>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade pt-3" id="nav-woocommerce" role="tabpanel" aria-labelledby="nav-woocommerce-tab">
                <label>Opnieuw aanmaken?</label>
                <select class="custom-select form-control" v-model="editProduct.woo_del">
                  <option value="0">Nee</option>
                  <option value="1">Ja</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="editProductsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Edit grouped products</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label>Trade</label><input type="text" class="form-control" v-model="editProduct.trade" placeholder="Trade" />
            <label>Retail</label><input type="text" class="form-control" v-model="editProduct.retail" placeholder="Retail" />
            <label>Tax(%)</label><input type="text" class="form-control" v-model="editProduct.tax" placeholder="Tax" />
            <label>Woo ID</label><input type="text" class="form-control" v-model="editProduct.woo_id" placeholder="Tax" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';
import draggable from 'vuedraggable';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS

export default {
  name: 'app',
  components: {
    draggable,
    VueSimpleSuggest
  },
  data() {
    return{
      editorOption: {
          modules: {
            toolbar: [
              [{ 'size': ['small', false, 'large'] }],
              ['bold', 'italic'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['link']
            ],
          }
      },
      /*REMOTE*/
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 25
      },
      /* END REMOTE */
      importType : '-1',
      importCategory: '-1',
      categories: [],
      imageUpload: [],
      groupedproducts: null,
      groupedproduct: null,
      groupedproductid: 1,
      products: null,
      singleproducts: null,
      test: null,
      inputgroupedproductid: null,
      productsSelected: [],
      groupedProductSelected: null,
      updateGroupedProduct: null,
      addNewGroupedProduct: null,
      selectAll: false,
      file: '',
      importfile: '',
      importfiles: '',
      editGroupedProduct: {
        id: '',
        name: '',
        use: '',
        collection: '',
        price: '',
        manufacturer: ''
      },
      editProduct: {
        attributes: [],
        related: [],
      },
      importFeedback: '',
      importFeedbackList: '',
      imgImportReady: false,
      csvKeys: '',
      sqlKeys: '',
      readyForImport: false,
      importStatus: 'Import',
      productColumns: [
        {label: 'R', field: 'rel', html: true},
        {label: 'I', field: 'img', html: true},
        {label: 'AN', field: 'an', filterOptions: {enabled: true}},
        {label: 'Name', field: 'name', filterOptions: {enabled: true}},
        {label: 'Color', field: 'color', filterOptions: {enabled: true}},
        {label: 'Trade', field: 'trade', filterOptions: {enabled: true}},
        {label: 'Retail', field: 'retail', filterOptions: {enabled: true}},
        {label: 'Category', field: 'category', filterOptions: {enabled: true}},
        {label: 'Woo ID', field: 'woo_id', filterOptions: {enabled: true}},
        {label: 'A', field: 'active_v', html: true},
      ],
      addGroupedProduct: '',
      addRelatedProduct: '',
      delSingleProducts: false
    }
  },
  mounted (){
    this.loadItems();
  },
  methods: {
    onEditorBlur(editor) {
         console.log('editor blur!', editor)
      },
      onEditorFocus(editor) {
         console.log('editor focus!', editor)
      },
      onEditorReady(editor) {
         console.log('editor ready!', editor)
      },
      customButtonClick() {
      },
    /* REMOTE */
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {

      this.updateParams({
        sort: params[0],
      });

      console.log(this.serverParams);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    // load items is what brings back the rows from server
    loadItems() {

        axios
          .post('https://wrc.weblion.be/api/remote-grouped-products/',
          {
            serverParams: this.serverParams
          })
          .then(response => {
            this.totalRecords = response.data.totalRecords;
            this.products = response.data.rows;
            console.log(response.data);
          })

    },
    /* END REMOTE */
    delProductsModal(){
      $("#deleteProductModal").modal('show');
    },
    delProducts(){
      var gp = this.editProduct;
      var products = this.productsSelected;
      var dsp = this.delSingleProducts;
      axios
        .post('https://wrc.weblion.be/api/delete-grouped-products.php/',
          {
            gp: gp,
            products: products,
            dsp: dsp
          })
        .then((response) => {
          console.log(response.data);
          this.getGroupedProducts();
          $("#deleteProductModal").modal('hide');
        })
    },
    addProduct(){
      var pid = this.addGroupedProduct.id;
      var vp = this.editProduct.id;
      axios
        .post('https://wrc.weblion.be/api/add-grouped-product.php/',
          {
            pid: pid,
            vp: vp
          })
        .then(() => {
          axios
            .post('https://wrc.weblion.be/api/grouped-products/',
              {
                id: vp
              })
            .then((response) => {
              this.$set(this.editProduct, 'products', response.data[0].products);
              this.addGroupedProduct = "";
            })
        })
    },
    addNewRelatedProduct(){
      var pid = this.addRelatedProduct.id;
      var vp = this.editProduct.id;
      axios
        .post('https://wrc.weblion.be/api/add-related-product.php/',
          {
            pid: pid,
            vp: vp
          })
        .then(() => {
          axios
          .post('https://wrc.weblion.be/api/related-products/',
            {
              id: vp
            })
          .then((response) => {
            this.$set(this.editProduct, 'related', response.data);
              this.addRelatedProduct = "";
            })
        })
    },
    closeImport(){
      this.csvKeys = '';
      this.sqlKeys = '';
      this.importFeedback = '';
      $("#importModal").modal('hide');
    },
    relatedStatusFn(rowObj){
      return "<span class='groupedState' data-g='" + rowObj.rel + "'><span>";
    },
    imagesStatusFn(rowObj){
      return "<span class='groupedState' data-g='" + rowObj.img + "'><span>";
    },
    sProduct(){

      var ids = null;

      if(this.productsSelected.length > 1){
        ids = [];
        for (var i = 0; i < this.productsSelected.length; i++) {
          ids.push(this.productsSelected[i].id);
        }
      }

        axios
          .post('https://wrc.weblion.be/api/grouped-products/update.php',
            {
              product: this.editProduct,
              ids: ids
            })
          .then((response) => {
            console.log(response.data);
            $("#editProductModal").modal('hide');
            $("#editProductsModal").modal('hide');
            this.loadItems();
          })

    },
    sRelatedProducts(){
      console.log(this.productsSelected);
      if(this.productsSelected.length > 1){
        axios
          .post('https://wrc.weblion.be/api/save_related_products.php',
            {
              products: this.productsSelected
            })
          .then(() => {
            this.loadItems();
          })
      }
    },
    saveGroupedProduct(){
      axios
        .post('https://wrc.weblion.be/api/save_grouped_product.php', {
            id: this.updateGroupedProduct,
            products: this.productsSelected,
            new: this.addNewGroupedProduct
        })
        .then(
          axios
          .get('https://wrc.weblion.be/api/products/')
          .then(response => (this.products = response.data))
        )
        .then(function () {
          this.loadItems();
        })
        .then(function () {
          $("#exampleModal").modal('hide');
        })
    },
    getGroupedProducts(){
      axios
        .get('https://wrc.weblion.be/api/products/')
        .then((response) => {
          console.log(response.data);
          this.singleproducts = response.data;
        })
        .then(()=>{
          axios
            .get('https://wrc.weblion.be/api/grouped-products/')
            .then((response) => {
              console.log(response.data);
              this.groupedproducts = response.data;
            })
        })
    },
    selectionChanged(table){
      this.productsSelected = table.selectedRows;
    },
    onRowClick(table){
      this.editProduct = table.row;
      var id = table.row.id;
      this.productsSelected = table.row;
      this.getGroupedProducts();
      axios
        .post('https://wrc.weblion.be/api/related-products/',
          {
            id: id
          })
        .then((response) => {
          this.$set(this.editProduct, 'related', response.data);
          $("#editProductModal").modal('show');
        })
    },
    modalEditProduct(){

      if(this.productsSelected.length == 1){
        this.editProduct = this.productsSelected[0];

        var id = this.editProduct.id;
        axios
          .post('https://wrc.weblion.be/api/related-products/',
            {
              id: id
            })
          .then((response) => {
            this.$set(this.editProduct, 'related', response.data);
            $("#editProductModal").modal('show');
          })

      }else if(this.productsSelected.length > 1){
        this.editProduct = {
          trade: null,
          retail: null,
          tax: null
        };

        $("#editProductsModal").modal('show');
      }


    },
    delProduct(product){
      var gid = this.editProduct.id;
      var id = product.id;
      axios
        .post('https://wrc.weblion.be/api/delete-grouped-product/',
          {
            id: id
          })
        .then(() => {
          axios
            .post('https://wrc.weblion.be/api/grouped-products/',
              {
                id: gid
              })
            .then((response) => {
              this.$set(this.editProduct, 'products', response.data[0].products);
            })
        })
    },
    delRelatedProduct(relation){
      var id = relation.id;
      axios
        .post('https://wrc.weblion.be/api/delete-related-product/',
          {
            id: id
          })
        .then(() => {
          axios.post('https://wrc.weblion.be/api/related-products/',
            {
              id: this.productsSelected.id
            })
          .then((response) => {
            this.$set(this.editProduct, 'related', response.data);
          })
        })
    },
    delImage(img){
      var id = img.id;
      var pid = this.editProduct.id;

      axios
        .post('https://wrc.weblion.be/api/delete-img.php',
          {
            id: id
          })
        .then(() => {
          axios
          .post('https://wrc.weblion.be/api/grouped-products/',
            {
              id: pid
            }
          )
          .then((response) => {
            this.$set(this.editProduct, 'images', response.data[0].images);
          })
        })
    },
    handleFileUpload(){
      this.imageUpload = this.$refs.file.files;
      for (var i = 0; i < this.$refs.file.files.length; i++) {
        this.importFeedbackList += this.$refs.file.files[i].name;
        this.importFeedbackList += "<br>";
      }
      this.imgImportReady = true;
    },
    handleImportUpload(){
      this.importfile = this.$refs.importfile.files[0];
      if(this.importfile.type != 'text/csv'){
        this.importFeedback = "Error: please upload a .csv file"
      }else{
        this.importFeedback = "Success: " + this.importfile.name + " is ready for upload";
      }
    },
    uploadCSV(){

      if(this.importfile != ''){
        let formData = new FormData();
        formData.append('file', this.importfile);

        axios.get('https://wrc.weblion.be/api/grouped-sql.php')
        .then( (response) => {

          this.sqlKeys = response.data;

          return axios.post('https://wrc.weblion.be/api/grouped-csv.php',formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            })

        })
        .then( (response) => {
          console.log(response.data);
          this.importFeedback = "Please match .csv columns to database";
          this.csvKeys = response.data;
          this.readyForImport = true;
        })
      }

    },
    importCSV(){

      this.importStatus = 'Importing...'

      let formData = new FormData();
      let match = JSON.stringify($("#frmImport").serializeArray());
      let sql = JSON.stringify(this.sqlKeys);
      let csv = JSON.stringify(this.csvKeys);

      formData.append('file', this.importfile);
      formData.append('sql', sql);
      formData.append('match', match );
      formData.append('csv', csv);
      formData.append('type', this.importType);

      axios
        .post('https://wrc.weblion.be/api/import_grouped_csv.php', formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        )
      .then(response => {
        console.log(response.data);
        this.importStatus = 'Import';
        this.closeImport();
        this.getGroupedProducts();
      })
    },
    modalImport(){
      axios
      .get('https://wrc.weblion.be/api/categories.php')
      .then((response) => {
        this.categories = response.data;
        $("#importModal").modal('show');
      })
    },
    modalAddRelated(){
      $("#editProductModal").modal('hide');
      $("#relatedModal").modal('show');
    },
    imagesMoved(){
      var images = this.editProduct.images;

      console.log(images);

      axios
        .post('https://wrc.weblion.be/api/update-img-pos.php',
          {
            images: images
          }
        )
        .then((response) => {
          console.log(response);
        })
    },
    addRelProduct(){
      var pid = this.productsSelected.id;
      console.log(pid);
    },
    importImages(){

      this.importFeedback = "Uploading...";

      let formData = new FormData();
      let id = this.editProduct.id;

      for( var i = 0; i < this.imageUpload.length; i++ ){
        let file = this.imageUpload[i];

        formData.append('images[]', file);
      }

      formData.append('id', id);

      axios
        .post('https://wrc.weblion.be/api/import_images.php', formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        )
      .then(() => {
        axios
          .post('https://wrc.weblion.be/api/grouped-products/',
            {
              id: id
            }
          )
          .then((response) => {
            this.$set(this.editProduct, 'images', response.data[0].images);
            this.importFeedbackList = '';
            this.imgImportReady = false;
            this.importFeedback = '';
          })
      })
    }

  }
}
</script>

<style>
button{
  margin-right: 10px;
}
.table thead th{
  text-align: left !important;
}
.pager ul{
  list-style-type: none;
}
.pager ul li{
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input{
  margin-bottom: 5px;
}
.modal-body label{
  display: inline-block;
  width: 32%;
}

#deleteProductModal .modal-body label{
  display: inline-block;
  width: 100%;
}

.modal-body .form-control, .quill-editor{
  display: inline-block;
  width: 68%;
}

.modal-body select{
  text-indent: 5px;
}

#exampleModal input{
  display: block;
  width: 100%;
}

#importModal .modal-body label{
  width: auto;
}

#importModal input, #importModal select{
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper, #importModal form{
  width: 100%;
}


#editProductModal .modal-content{
  width: 750px;
}

.btn-del{
  width: 27px;
    height: 27px;
    line-height: 23px;
    font-size: 13px;
    font-weight: bold;
}

.dropdown{
  display: inline-block;
}
.dropdown-item:hover{
  cursor: pointer !important;
}
.dropdown-item i{
  margin-right:3px;
}
@media (min-width: 576px){
  .modal-dialog {
      max-width: 750px;
      margin: 1.75rem auto;
  }
}
.groupedState{
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

[data-g='1']{
  background: #8CC040;
}

[data-g='0']{
  background: red;
}

#nav-images label{
  width: auto;
}

#nav-images p{
  width: 100%;
  margin-bottom: 2px;
}


.img-preview{
  display: inline-block;
  margin: 10px;
  background-size: cover;
  width: 33%;
  height: 100px;
  float: left;
}

.importFeedback{
  color: #777;
  font-size: 14px;
  line-height: 37px;
}

.importFeedbackList{
  color: #777;
  font-size: 14px;
  line-height: 37px;
  line-height: 20px;
}


.sticky-nav{
  position: fixed;
    height: 150px;
    top: 50;
    z-index: 2;
    background: white;
    padding-top: 10px;
        width: 100%;
        margin-top: -10px;
}

.preview{
  height: 50px;
  width: auto;
}

#nav-images td{
  vertical-align: middle;
}

#nav-images tr:hover{
  cursor: move;
}

.btn-add{
  margin-bottom: 10px;
  padding: 6px 12px;
}


.vgt-wrap{
  margin-top: 120px;
}

#importModal select{
  margin-left: 0;
}
</style>
